export default (() => {

    function isFunction (value) {
        return typeof value === 'function';
    }

    function toFunction (value) {
        if (value === undefined) {            
            return wealthify.error.throwError('type.function.toFunction', 'value must be defined');
        }

        if (typeof value !== 'string' && !isFunction(value)) {
            return wealthify.error.throwError('type.function.toFunction', 'value must be typeof function or string');
        }

        if (typeof value === 'string') {
            return new Function(`return ${value}`)();
        }

        return value;    
    }

    function toFunctionFromReference (value) {
        if (value === undefined) {            
            return wealthify.error.throwError('type.function.toFunctionFromReference', 'value must be defined');
        }

        if (typeof value !== 'string' && !isFunction(value)) {
            return wealthify.error.throwError('type.function.toFunctionFromReference', 'value must be typeof function or string');
        }

        if (typeof value === 'string') {
            let scope = window;
    
            value.split('.').forEach((level) => scope = scope[level]);

            return scope;
        }

        return value;
    }

    return {
        isFunction,
        toFunction,
        toFunctionFromReference
    };

})();